// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.owner-statement-table-separator-1[data-v-1d3f0e67]{border:0;height:2px;margin:0 0px 20px 0px}div.owner-statement-table-separator-2[data-v-1d3f0e67]{border:0;height:2px;background:rgba(29,174,247,.2);box-shadow:0 2px 5px rgba(29,174,247,.5);margin:0 3px 20px 3px}div.grid-container[data-v-1d3f0e67]{padding:0 40px 0 40px}@media(max-width: 991.98px){div.grid-container[data-v-1d3f0e67]{padding:0}}", ""]);
// Exports
module.exports = exports;
